<template>
  <section class="trusted-companies-section pt-120 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="section-title text-center mb-70">
            <h2>{{ content.header.title }}</h2>
            <p>{{ content.header.description }}</p>
          </div>
        </div>
      </div>

      <div class="companies-slider">
        <div class="swiper companies-swiper" ref="companiesSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(company, index) in content.companies" :key="index">
              <div class="company-item">
                <img :src="company.logo" :alt="company.name" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'
import { Swiper } from 'swiper'
import 'swiper/css'

export default {
  name: 'TechItsTrustedCompaniesComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup() {
    const companiesSwiper = ref(null)

    const initCompaniesSwiper = () => {
      if (companiesSwiper.value) {
        new Swiper(companiesSwiper.value, {
          slidesPerView: 5,
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          loop: true,
          breakpoints: {
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          },
        })
      }
    }

    onMounted(() => {
      initCompaniesSwiper()
    })

    return {
      companiesSwiper
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Trusted Companies Section */
.trusted-companies-section {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 100px;
  background: #fff;
}

.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.section-title p {
  font-size: 16px;
  color: #6c757d;
  line-height: 1.8;
}

.section-title.text-center {
  text-align: center;
}

.companies-slider {
  margin-top: 50px;
}

.company-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 20px;
  transition: all 0.3s ease;
  border: 1px solid rgba(246, 236, 79, 0.2);
}

.company-item:hover {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-color: #f6ec4f;
  transform: translateY(-5px);
}

.company-item img {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
  filter: grayscale(100%);
  transition: all 0.3s ease;
}

.company-item:hover img {
  filter: grayscale(0%);
}

/* Swiper Styles */
.companies-swiper {
  overflow: hidden;
}

.swiper-slide {
  height: auto;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .trusted-companies-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .trusted-companies-section {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 32px;
  }
  
  .company-item {
    height: 100px;
    padding: 15px;
  }
  
  .company-item img {
    max-height: 60px;
  }
}

@media only screen and (max-width: 399px) {
  .trusted-companies-section {
    padding: 40px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .company-item {
    height: 80px;
    padding: 10px;
  }
  
  .company-item img {
    max-height: 50px;
  }
}
</style>
